import React from "react";
import {Route} from "react-router-dom";

import RiskIndex from "./index";

const data = [<Route exact key="RiskIndex" path="/risk/index" element={<RiskIndex />} />];

export default data;
